<div class="table-container mat-mdc-card"> 
  @if(!contactEvents){
  <div><code>Loading ...</code></div>
  }
  @else{
  <app-datatable-component [data]="contactEvents" [columns]="contactEventColumns"></app-datatable-component>
  }
</div>

